import { render, staticRenderFns } from "./SuggestedWaiting.vue?vue&type=template&id=1611619a&scoped=true"
import script from "./SuggestedWaiting.vue?vue&type=script&lang=js"
export * from "./SuggestedWaiting.vue?vue&type=script&lang=js"
import style0 from "./SuggestedWaiting.vue?vue&type=style&index=0&id=1611619a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1611619a",
  null
  
)

export default component.exports